<p-dialog
  header="Add Item Type"
  appendTo="body"
  [modal]="true"
  [(visible)]="visibleItemPopup"
  [breakpoints]="{ '991px': '90vw' }"
  [style]="{ width: '35vw' }"
  showEffect="fade"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeJobDialog(false)">
  <div class="">
    <div *ngIf="loading" class="p-fluid p-formgrid grid gap-3 px-3 pt-3">
      <div class="p-formgrid">
        <div class="field">
          <label>Name</label>
          <p-skeleton
            width="100%"
            height="1.5rem"
            styleClass="mb-2"></p-skeleton>
        </div>
      </div>
    </div>
    <div *ngIf="!loading" class="p-fluid p-formgrid grid gap-3 px-3 pt-3">
      <div class="field p-formgrid">
        <div class="field">
          <label>Name</label>
          <input
            type="text"
            pInputText
            [(ngModel)]="name"
            placeholder="Enter Name"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="nameOnChange($event)" />
          <span class="mt-2 text-red-600" *ngIf="doesNameExists">
            This Item Name exists.. Please type a different name
          </span>
        </div>
      </div>
    </div>
    <div class="flex items-center justify-end">
      <button
        [loading]="saveJobLoading"
        pButton
        pRipple
        [disabled]="!disableSaveBtn"
        type="button"
        class="rounded-full w-fit"
        (click)="saveItemData()">
        Save
      </button>
    </div>
  </div>
</p-dialog>
